import { render, staticRenderFns } from "./articleviewCMS.vue?vue&type=template&id=5ab3d8ea&scoped=true"
import script from "./articleviewCMS.vue?vue&type=script&lang=js"
export * from "./articleviewCMS.vue?vue&type=script&lang=js"
import style0 from "./articleviewCMS.vue?vue&type=style&index=0&id=5ab3d8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab3d8ea",
  null
  
)

export default component.exports